import { abreviarNome } from "../../utils/abreviaNome";
import { getCertificateImageUrl } from "../../utils/certificate-image";
import { standardizeName } from "../../utils/helpers";
import {
  type CertificateNameLayout,
  DEFAULT_CERTIFICATE_NAME_LAYOUT,
} from "../../types/certificate-name-layout.interface";

interface IProps {
  id: string;
  name: string;
  event_id: string;
  /** Quando omitido, usa o layout padrão (equivalente ao visual anterior em telas médias). */
  nameLayout?: CertificateNameLayout;
}

export default function Certificado({
  id,
  name,
  event_id,
  nameLayout,
}: IProps) {
  const formatName = abreviarNome(standardizeName(name));
  const layout: CertificateNameLayout = {
    ...DEFAULT_CERTIFICATE_NAME_LAYOUT,
    ...nameLayout,
  };
  const imageSrc = getCertificateImageUrl(event_id);

  return (
    <div className="relative text-center" id={`print_${id}`}>
      <img
        src={imageSrc}
        alt="certificado"
        className="h-full w-full object-cover"
      />
      <h1
        className="font-personalizada absolute box-border w-full px-4 text-[var(--color-certificate)]"
        style={{
          top: `${layout.topPercent}%`,
          left: `${layout.leftPercent}%`,
          transform: `translate(${layout.translateXPercent}%, ${layout.translateYPercent}%)`,
          fontSize: `${layout.fontSizeRem}rem`,
          lineHeight: 1.15,
        }}
      >
        {formatName}
      </h1>
    </div>
  );
}
